import { Button, Flex, Text } from '@chakra-ui/react'

import Card from 'components/Card/Card'
import CardBody from 'components/Card/CardBody'
import CardHeader from 'components/Card/CardHeader'
import LivesTable from './LivesTable'

import Layout from 'components/ManagerLayout'
import { Link } from 'react-router-dom'

interface Props {
    highRisk: boolean
}

const Lives = ({ highRisk = false }: Props) => {
    return (
        <Layout>
            <Card>
                <CardHeader>
                    <Flex w="full" justifyContent="space-between" alignItems="center">
                        <Text>Vidas {highRisk && "com Alto Risco"}</Text>
                        {/* <Link to="cadastrar">
                            <Button colorScheme="blue" size="md">Cadastrar Vida</Button>
                        </Link> */}
                    </Flex>
                </CardHeader>
                <CardBody>
                    <LivesTable highRisk={highRisk} />
                </CardBody>
            </Card>
        </Layout>
    )
}

export default Lives